// Removed import from @shared/documents
import { Link, useNavigate } from 'react-router-dom';

import { getUnitatColor, getUnitatName } from '../../utils/unitats';

import * as S from './PostSummary.styles';

// Define the types locally
interface PostElementDoc {
	type: string;
	content: string;
	thumbnail?: string;
}

interface PostDocument {
	_id: string;
	title: string;
	elements: PostElementDoc[];
	upload_date: Date | string;
	data_actualitzacio: Date | string;
	unitat?: string;
	url: string;
	data_publicacio_dd_mm_yyyy?: string;
	data_actualitzacio_dd_mm_yyyy?: string;
	preview_image: number;
}

/**
 * Extract YouTube video ID from various YouTube URL formats.
 */
const extractYouTubeId = (url: string): string | null => {
	const patterns = [
		/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/live\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
		/^([a-zA-Z0-9_-]{11})$/, // bare video ID
	];
	for (const pattern of patterns) {
		const match = url.match(pattern);
		if (match) return match[1];
	}
	return null;
};

const PostSummary = ({ postData }: { postData: PostDocument }) => {
	const navigate = useNavigate();

	const firstImage = postData.elements.find(
		(element) => element.type === 'image'
	);

	const firstVideo = postData.elements.find(
		(element) => element.type === 'video'
	);

	const firstVideoSelf = postData.elements.find(
		(element) => element.type === 'video_self'
	);

	const videoThumbnail = firstVideo
		? extractYouTubeId(firstVideo.content)
		: null;

	const previewSrc = firstImage
		? firstImage.content
		: firstVideoSelf?.thumbnail
			? firstVideoSelf.thumbnail
			: videoThumbnail
				? `https://img.youtube.com/vi/${videoThumbnail}/hqdefault.jpg`
				: null;

	const handleClick = () => {
		navigate(`/posts/${postData._id}`);
	};

	const formatDate = (date: string | Date) => {
		const d = new Date(date);
		return d.toLocaleDateString('ca-ES', {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
		});
	};

	const accentColor = getUnitatColor(postData.unitat);
	const unitatName = getUnitatName(postData.unitat);

	return (
		<S.PostCard
			as={Link}
			to={`/posts/${postData._id}`}
			onClick={handleClick}
			aria-label={postData.title}
		>
			{previewSrc && (
				<S.PostImage
					src={previewSrc}
					alt={postData.title}
				/>
			)}
			<S.PostContent $color={accentColor}>
				<S.PostTitle>{postData.title}</S.PostTitle>
				<S.PostInfo>
					<S.PostUnitat $color={accentColor}>
						{unitatName}
					</S.PostUnitat>
					<S.PostDate>
						{formatDate(postData.upload_date)}
					</S.PostDate>
				</S.PostInfo>
			</S.PostContent>
		</S.PostCard>
	);
};

export default PostSummary;